<div class="brand-loader" [class.is-leaving]="leaving()"
    role="progressbar" [attr.aria-label]="label()"
    aria-valuemin="0" aria-valuemax="100"
    [attr.aria-valuenow]="ariaValue()"
    [attr.aria-valuetext]="ariaValue() + '%'">
    <div class="brand-loader__stage" [style.--progress]="progress()">
        <div class="brand-loader__logo">
            <img class="brand-loader__logo-base" src="assets/logo-nordsol.png"
                alt="" aria-hidden="true" />
            <img class="brand-loader__logo-fill" src="assets/logo-nordsol.png"
                alt="Nordsol Energia Inteligente" />
        </div>
        <div class="brand-loader__counter" aria-hidden="true">
            <span class="brand-loader__value">{{ value() }}</span>
            <span class="brand-loader__unit">%</span>
        </div>
        <p class="brand-loader__status" aria-live="polite">{{ status() }}</p>
    </div>
</div>
